const unreadableText = /\uFFFD|锟斤拷|Ã[^\x00-\x7f]|Â[^\x00-\x7f]/u;

export function publicProfileText(value: string, fallback = "暂无数据") {
  const text = value.trim();
  return text && !unreadableText.test(text) ? text : fallback;
}

export function publicWeight(value: number | undefined, verified = false) {
  if (value === undefined) return "";
  // Historical profiles did not record a unit; values in this range may be 斤.
  // Never infer or convert a person's measurement without checking its source.
  if (!Number.isFinite(value)) return "体重待核实";
  return (value >= 30 && value < 90) || (verified === true && value >= 20 && value <= 300)
    ? `${value}kg` : "体重待核实";
}

export function publicPhysique(height: number | undefined, weight: number | undefined = undefined, weightVerified = false) {
  const heightLabel = height === undefined ? "" : Number.isFinite(height) && height >= 100 && height <= 250
    ? `${height}cm` : "身高待核实";
  return [heightLabel, publicWeight(weight, weightVerified)].filter(Boolean).join(" / ") || "身形暂无数据";
}

/** Optional profile fields should not render missing-data placeholders. */
export function optionalProfileText(value: string) {
  const text = publicProfileText(value, "");
  return /^(?:简介|身份|地区|城市|身形)?暂无数据$/u.test(text) ? "" : text;
}
